import { transferCruise } from '@/_config/transfer';
import Button from '@/comp/button/button';
import { Icon } from '@/comp/icon/icon';
import type { TransferOffer, TransferTypeConfig } from '@/model/upsell/transfer';

// Styles
import './offer-entry.scss';

function lookupTransferConfig(tariffCode: string): TransferTypeConfig {
    const key = tariffCode.toLowerCase();
    return Object.entries(transferCruise).find(([k]) => k === key)?.[1] ?? transferCruise.shuttle;
}

interface OfferEntryProps {
    transferOffer: TransferOffer;
    onSelection: (offerKey: string) => void;
    selectedOffer: string | null;
}

const OfferEntry = ({ transferOffer, onSelection, selectedOffer }: OfferEntryProps) => {
    const { transferTime, price, offerKey, tariffCode } = transferOffer;
    const { icon, label, subline, details } = lookupTransferConfig(tariffCode);

    const handleSelection = (offerKey: string) => {
        onSelection(offerKey);
    };

    const selected = selectedOffer === offerKey;

    return (
        <div
            className={`offer-entry ${selected ? 'selected' : ''}`}
            key={offerKey}
            onClick={() => handleSelection(offerKey)}>
            <div className="transfer-option">
                <div className="transfer-option-icon">
                    <Icon name={icon} />
                </div>
                <div>
                    <div className="transfer-option-label">{label}</div>
                    <div className="transfer-option-subline">{subline}</div>
                </div>
            </div>
            <div className="price">
                <p className="price-value">{price.overallGrossPrice} €</p>
                <p className="price-label">Gesamtpreis</p>
            </div>
            <ul className="details">
                {details.map((detail: string, i: number) => (
                    <li key={i}>{detail}</li>
                ))}
            </ul>
            <div className="transferTime">{transferTime} min</div>

            <div className="selection">
                <Button
                    label={selected ? 'ausgewählt' : 'auswählen'}
                    classList={selected ? 'button-ghost selected' : 'button-ghost'}
                    icon={selected ? 'checkCircleFilled' : undefined}
                />
            </div>
        </div>
    );
};

export default OfferEntry;
